import React from "react";
import { SuscripcionUsuario } from "./SuscripcionUsuario";
import {connect} from "react-redux";
import queryString from "query-string";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import Moment from "react-moment";
import ReactSwitch from "react-switch";
import ReactStars from "react-rating-stars-component";
import {NumericFormat as NumberFormat} from "react-number-format";
import {productoActions} from "../../../_actions";
import {history, LoadingBoton} from "../../../_helpers";
import {NavBarLateral} from "../../includes";
import authService from "../../../_services/cart/authService";
import userServiceTs from "../../../_services/cart/userService";
import http from "../../../_services/cart/http.service";
import alertService from "../../../_services/cart/alert.service";
import impersonacionService from "../../../_services/cart/impersonacion.service";
import {userService} from "../../../_services";
import {FormEditarMP} from "./FormEditarMP";
import {FormEditarPerfil} from "./FormEditarPerfil";
import {FormResetearPassword} from "./FormResetearPassword";
import {VentasUsuarioModal} from "./VentasUsuarioModal";
import {ReseniasUsuarioModal} from "./ReseniasUsuarioModal";

/** Cuántos movimientos adelanta cada tarjeta antes del "ver todas". Igual que el backend. */
const ULTIMAS_EN_RESUMEN = 3;

/** Un dato del usuario, con su etiqueta. Vacío no se dibuja: un renglón en blanco no informa nada. */
const Dato = ({etiqueta, children}) =>
    children === undefined || children === null || children === "" ? null : (
        <div className="user-detail__dato">
            <p>{etiqueta}</p>
            <span>{children}</span>
        </div>
    );

/** Una credencial de Mercado Pago. Las muestra enteras: son lo que el admin viene a verificar. */
const Credencial = ({etiqueta, valor}) => (
    <div className="user-detail__dato user-detail__dato--credencial">
        <p>{etiqueta}</p>
        <span>{valor || <em className="user-detail__vacio">sin cargar</em>}</span>
    </div>
);

/**
 * Una fila del adelanto de compras/ventas: con quién, cuánto y cuándo, y el ojo al detalle.
 *
 * <p>Es a propósito una lista y no una tabla: son tres filas, y una tabla con su encabezado y su
 * paginador pesaría más que el dato. La tabla completa está a un click, en el modal.
 */
const FilaMovimiento = ({venta, contraparte}) => (
    <li className="user-detail__mov">
        <Link to={"/comprador/compraDetail?id=" + venta.id} className="user-detail__mov-link">
            <span className="user-detail__mov-quien">
                {authService.formatUserName(contraparte) || "—"}
            </span>
            <span className="user-detail__mov-total">
                <NumberFormat prefix={"$"} value={venta.total} displayType={"text"}
                              thousandSeparator="." decimalSeparator=","/>
            </span>
            <span className="user-detail__mov-estado">{venta.estado}</span>
            <Moment className="user-detail__mov-fecha" date={venta.createdDate} format="DD/MM/YY"/>
        </Link>
    </li>
);

/**
 * El detalle de un usuario visto por el admin.
 *
 * <p>La página contesta, de arriba a abajo, tres preguntas distintas: quién es (cabecera), qué
 * tiene cargado (las tarjetas de datos) y qué hizo en el sitio (el resumen de actividad). Los
 * listados de abajo son un adelanto de {@value ULTIMAS_EN_RESUMEN} movimientos con el total al
 * lado, y lo completo vive en los modales: en el 90% de las visitas alcanza con el número, y
 * meter tres tablas paginadas en la misma pantalla las volvía imposibles de leer.
 */
class UsuarioDetail extends React.Component {
    state = {
        usuario: undefined,
        error: undefined,
        resumen: undefined,
        showMp: false,
        showPerfil: false,
        showPassword: false,
        showResenias: false,
        // undefined = cerrado; "COMPRAS" | "VENTAS" = abierto en esa solapa.
        tabMovimientos: undefined
    };

    componentDidMount() {
        this.cargar();
    }

    /** El id del usuario que se está mirando, que viaja en el query string. */
    usuarioId = () => queryString.parse(this.props.location.search).id;

    cargar = () => {
        const id = this.usuarioId();

        userServiceTs.getUsuarioById(id, this.setUsuario);

        userService.traerResumenUsuario(id).then(
            (data) => this.setState({resumen: data}),
            // El resumen es informativo: si falla, la ficha del usuario igual se muestra.
            (error) => alertService.error(error)
        );
    };

    setUsuario = (data) => {
        if (data.error) {
            this.setState({error: data.error});
        } else {
            this.setState({usuario: data.usuario});
        }
    };

    /**
     * Los tres switches de la cabecera. Pintan el estado nuevo apenas responde el server para que
     * el switch no quede a medio camino.
     */
    /** Impersonacion: la app se recarga ya con la sesion del usuario (ver authService). */
    entrarComo = (usuario, nombre) => {
        this.setState({entrando: true});
        impersonacionService.entrar(usuario.id, {nombre, email: usuario.email})
            .catch((err) => {
                this.setState({entrando: false});
                alertService.error(err?.message || "No se pudo entrar como este usuario");
            });
    };

    toogle = (campo, value) => {
        let usuario = this.state.usuario;
        let body = {id: usuario.id};

        body[campo] = value;

        http
            .post("api/admin/users/toogle", body)
            .then(() => {
                usuario[campo] = value;
                this.setState({usuario: usuario});
            })
            .catch((error) => {
                alertService.error(error);
            });
    };

    /** Al cerrar cualquier modal de edición se relee el usuario: lo editado se ve sin recargar. */
    recargarUsuario = () => {
        userServiceTs.getUsuarioById(this.usuarioId(), this.setUsuario);
    };

    handleCloseMp = () => {
        this.setState({showMp: false});
        this.recargarUsuario();
    };

    handleClosePerfil = () => {
        this.setState({showPerfil: false});
        this.recargarUsuario();
    };

    handleClose = () => {
        this.setState({
            showMp: false,
            showPerfil: false,
            showPassword: false,
            showResenias: false,
            tabMovimientos: undefined
        });
    };

    /** "Belgrano 123 - Córdoba (5000), Córdoba", saltando lo que no esté cargado. */
    ubicacion = (usuario) => {
        const linea1 = usuario.direccion;
        const ciudad = [usuario.ciudad, usuario.codigoPostal ? "(" + usuario.codigoPostal + ")" : null]
            .filter(Boolean)
            .join(" ");
        const linea2 = [ciudad, usuario.provincia?.nombre].filter(Boolean).join(", ");

        return [linea1, linea2].filter(Boolean).join(" - ");
    };

    render() {
        if (!authService.hasAuthority("ADMIN")) {
            history.push("/");
        }

        const {usuario, error, resumen} = this.state;

        if (error !== undefined) {
            return (
                <div className="dashboard">
                    <NavBarLateral handleClose={this.handleClose}/>
                    <div className="dashboard__content">
                        <Row>
                            <Col>Existe un error con el usuario seleccionado: {error}</Col>
                        </Row>
                    </div>
                </div>
            );
        }

        if (usuario === undefined) {
            return (
                <div className="dashboard">
                    <NavBarLateral handleClose={this.handleClose}/>
                    <div className="dashboard__content">
                        <Row>
                            <Col><LoadingBoton grabando={true}/></Col>
                        </Row>
                    </div>
                </div>
            );
        }

        const nombre = authService.formatUserName(usuario);
        const resenias = usuario.sellerReviews || [];
        const ultimasCompras = resumen?.ultimasCompras || [];
        const ultimasVentas = resumen?.ultimasVentas || [];

        return (
            <>
                <div className="dashboard">
                    <NavBarLateral handleClose={this.handleClose}/>
                    <div className="dashboard__content">
                        <div className="dashboard__content-header">
                            <div className="dashboard__content-title">
                                <h2>Usuario #{usuario.id}</h2>
                            </div>
                            <Link className="button" data-type="secondary" to="/admin/usuarios">
                                <FontAwesomeIcon icon="fa-solid fa-arrow-left"/> Volver al listado
                            </Link>
                        </div>

                        {/*
                            Cabecera: quién es y qué se puede hacer con la cuenta. Los switches
                            estaban antes perdidos entre los datos de contacto, y son lo único de
                            esta pantalla que cambia algo con un solo click.
                        */}
                        <div className="dashboard__content-main">
                            <div className="user-detail__hero">
                                <div className="user-detail__identidad">
                                    <div className="user-detail__avatar" aria-hidden="true">
                                        {(nombre || "?").charAt(0).toUpperCase()}
                                    </div>
                                    <div>
                                        <h3>{nombre}</h3>
                                        <p className="user-detail__mail">{usuario.email}</p>
                                        <div className="user-detail__chips">
                                            <span className={"user-detail__chip " + (usuario.activo
                                                ? "user-detail__chip--ok"
                                                : "user-detail__chip--off")}>
                                                {usuario.activo ? "Activo" : "Inactivo"}
                                            </span>
                                            <span className="user-detail__chip">
                                                {usuario.esVendedor ? "Vendedor" : "Comprador"}
                                            </span>
                                            {usuario.esVendedor && (
                                                <span className={"user-detail__chip " + (usuario.mercadoPagoHabilitado
                                                    ? "user-detail__chip--ok"
                                                    : "user-detail__chip--off")}>
                                                    Mercado Pago {usuario.mercadoPagoHabilitado ? "habilitado" : "sin habilitar"}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="user-detail__acciones">
                                    {usuario.numeroCelular && (
                                        <a className="button" data-type="message" target="_blank"
                                           rel="noopener noreferrer"
                                           href={productoActions.crearLinkWhatsappAUsuario(usuario)}>
                                            <FontAwesomeIcon icon="fa-brands fa-whatsapp" size="lg"/>{" "}
                                            Escribirle
                                        </a>
                                    )}
                                    <button className="button" data-type="secondary" type="button"
                                            onClick={() => this.setState({showPerfil: true})}>
                                        <FontAwesomeIcon icon="fa-solid fa-pen"/> Editar perfil
                                    </button>
                                    <button className="button" data-type="secondary" type="button"
                                            onClick={() => this.setState({showPassword: true})}>
                                        <FontAwesomeIcon icon="fa-solid fa-key"/> Blanquear contraseña
                                    </button>
                                    {/* A quien no se puede (otro admin, un comprador de una tienda
                                        propia) lo frena el back con el motivo. */}
                                    <button className="button" data-type="primary" type="button"
                                            disabled={this.state.entrando}
                                            onClick={() => this.entrarComo(usuario,
                                                `${usuario.firstName || ""} ${usuario.lastName || ""}`.trim())}>
                                        <FontAwesomeIcon icon="fa-solid fa-user-secret"/> Entrar como este usuario
                                    </button>
                                </div>
                            </div>

                            <div className="user-detail__switches">
                                <label className="switch__container">
                                    <span>Activo</span>
                                    <ReactSwitch onChange={(v) => this.toogle("activo", v)}
                                                 checked={!!usuario.activo} onColor="#FF962E"/>
                                </label>
                                <label className="switch__container">
                                    <span>¿Es vendedor?</span>
                                    <ReactSwitch onChange={(v) => this.toogle("esVendedor", v)}
                                                 checked={!!usuario.esVendedor} onColor="#FF962E"/>
                                </label>
                                {usuario.esVendedor && (
                                    <label className="switch__container">
                                        <span>Mercado Pago habilitado</span>
                                        <ReactSwitch onChange={(v) => this.toogle("mercadoPagoHabilitado", v)}
                                                     checked={!!usuario.mercadoPagoHabilitado}
                                                     onColor="#FF962E"/>
                                    </label>
                                )}
                            </div>
                        </div>

                        {/* Qué tiene cargado la cuenta. */}
                        <div className="user-detail__grid">
                            <section className="user-detail__card">
                                <h4>Contacto y ubicación</h4>
                                <Dato etiqueta="Email">{usuario.email}</Dato>
                                <Dato etiqueta="Celular">{usuario.numeroCelular}</Dato>
                                <Dato etiqueta="Dirección">{this.ubicacion(usuario)}</Dato>
                                <Dato etiqueta="Coordenadas">
                                    {usuario.latitud && usuario.longitud
                                        ? usuario.latitud + ", " + usuario.longitud
                                        : undefined}
                                </Dato>
                                <button className="button" data-type="secondary" type="button"
                                        onClick={() => this.setState({showPerfil: true})}>
                                    Editar datos
                                </button>
                            </section>

                            {usuario.esVendedor && (
                                <section className="user-detail__card">
                                    <h4>Cobros</h4>
                                    <Dato etiqueta="CBU">{usuario.cbu}</Dato>
                                    <Dato etiqueta="Alias">{usuario.alias}</Dato>
                                    <Credencial etiqueta="MP Public Key" valor={usuario.mercadoPagoPublicKey}/>
                                    {/* Los secretos no se muestran: solo si estan cargados. Al habilitar
                                        MercadoPago el back prueba el access token contra MP. */}
                                    <Credencial etiqueta="MP Private Key" valor={usuario.mercadoPagoPrivateKeyCargada ? "cargada" : null}/>
                                    <Credencial etiqueta="MP Webhook Key" valor={usuario.mercadoPagoWebhookKeyCargada ? "cargada" : null}/>
                                    <button className="button" data-type="secondary" type="button"
                                            onClick={() => this.setState({showMp: true})}>
                                        Editar credenciales
                                    </button>
                                </section>
                            )}

                            <SuscripcionUsuario userId={usuario.id}/>
                        </div>

                        {/*
                            Actividad. El número grande primero y el adelanto debajo: el admin entra
                            acá para saber si la cuenta se usa, y recién después para ver qué hizo.
                        */}
                        <div className="dashboard__content-header">
                            <div className="dashboard__content-title">
                                <h2>Actividad</h2>
                            </div>
                        </div>

                        <div className="user-detail__grid">
                            <section className="user-detail__card user-detail__card--stat">
                                <h4>Compras</h4>
                                <p className="user-detail__numero">{resumen?.cantidadCompras ?? "—"}</p>
                                <p className="user-detail__subnumero">
                                    <NumberFormat prefix={"$"} value={resumen?.montoCompras ?? 0}
                                                  displayType={"text"} thousandSeparator="."
                                                  decimalSeparator=","/>{" "}
                                    comprados
                                </p>

                                {ultimasCompras.length === 0
                                    ? <p className="user-detail__vacio">Todavía no compró nada.</p>
                                    : (
                                        <ul className="user-detail__movs">
                                            {ultimasCompras.map((venta) => (
                                                <FilaMovimiento key={venta.id} venta={venta}
                                                                contraparte={venta.vendedor}/>
                                            ))}
                                        </ul>
                                    )}

                                <button className="button" data-type="secondary" type="button"
                                        disabled={!resumen?.cantidadCompras}
                                        onClick={() => this.setState({tabMovimientos: "COMPRAS"})}>
                                    Ver todas
                                </button>
                            </section>

                            <section className="user-detail__card user-detail__card--stat">
                                <h4>Ventas</h4>
                                <p className="user-detail__numero">{resumen?.cantidadVentas ?? "—"}</p>
                                <p className="user-detail__subnumero">
                                    <NumberFormat prefix={"$"} value={resumen?.montoVentas ?? 0}
                                                  displayType={"text"} thousandSeparator="."
                                                  decimalSeparator=","/>{" "}
                                    facturados
                                </p>

                                {ultimasVentas.length === 0
                                    ? <p className="user-detail__vacio">Todavía no vendió nada.</p>
                                    : (
                                        <ul className="user-detail__movs">
                                            {ultimasVentas.map((venta) => (
                                                <FilaMovimiento key={venta.id} venta={venta}
                                                                contraparte={venta.comprador}/>
                                            ))}
                                        </ul>
                                    )}

                                <button className="button" data-type="secondary" type="button"
                                        disabled={!resumen?.cantidadVentas}
                                        onClick={() => this.setState({tabMovimientos: "VENTAS"})}>
                                    Ver todas
                                </button>
                            </section>

                            <section className="user-detail__card user-detail__card--stat">
                                <h4>Reseñas</h4>
                                <p className="user-detail__numero">{resenias.length}</p>
                                {/*
                                    La calificación sólo aparece si alguien calificó: "0 de 5" en una
                                    cuenta nueva miente —dice que le fue mal, no que nadie opinó.
                                */}
                                {resenias.length > 0 && (
                                    <p className="user-detail__subnumero">
                                        <ReactStars value={Number(usuario.rating) || 0} edit={false}
                                                    size={18} isHalf={true} activeColor="#ffd700"/>
                                    </p>
                                )}

                                {resenias.length === 0
                                    ? <p className="user-detail__vacio">Todavía no recibió reseñas.</p>
                                    : (
                                        <ul className="user-detail__movs">
                                            {resenias.slice(0, ULTIMAS_EN_RESUMEN).map((review, i) => (
                                                <li className="user-detail__mov" key={i}>
                                                    <span className="user-detail__mov-quien">
                                                        {review.buyerMemberAccount?.username ?? "Comprador"}
                                                    </span>
                                                    <span className="user-detail__mov-resenia">
                                                        {review.observation || review.title}
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}

                                <button className="button" data-type="secondary" type="button"
                                        disabled={resenias.length === 0}
                                        onClick={() => this.setState({showResenias: true})}>
                                    Ver todas
                                </button>
                            </section>
                        </div>
                    </div>
                </div>

                {this.state.showMp && (
                    <FormEditarMP usuario={usuario} show={this.state.showMp}
                                  handleCloseMp={this.handleCloseMp}/>
                )}

                {this.state.showPerfil && (
                    <FormEditarPerfil usuario={usuario} show={this.state.showPerfil}
                                      handleClosePerfil={this.handleClosePerfil}/>
                )}

                {this.state.showPassword && (
                    <FormResetearPassword usuario={usuario} show={this.state.showPassword}
                                          handleClose={() => this.setState({showPassword: false})}/>
                )}

                {this.state.tabMovimientos !== undefined && (
                    <VentasUsuarioModal usuario={usuario} show={true}
                                        tabInicial={this.state.tabMovimientos}
                                        handleClose={() => this.setState({tabMovimientos: undefined})}/>
                )}

                {this.state.showResenias && (
                    <ReseniasUsuarioModal usuario={usuario} resenias={resenias} show={true}
                                          handleClose={() => this.setState({showResenias: false})}/>
                )}
            </>
        );
    }
}

function mapState(state) {
    return {};
}

const actionCreators = {};

const connectedUsuarioDetail = connect(mapState, actionCreators)(UsuarioDetail);
export {connectedUsuarioDetail as UsuarioDetail};
